import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft } from "lucide-react";
import { api, useContent, useMe, useSettings } from "@/lib/api";
import { PageHead, Section, Tag } from "@/components/site/Bits";
import ApplyForm, { CITY_FIELDS } from "@/components/site/ApplyForm";

export const STATUS = { pending: ["قيد المراجعة", "mute"], accepted: ["مقبول", "ice"], rejected: ["مرفوض", "gold"] };
export const TYPE_LABEL = { city: "المدينة", lspd: "LSPD", ems: "EMS", fire: "الدفاع المدني", justice: "القضاء", gang: "العصابات", fbi: "FBI" };

function MyApps() {
  const { data: me } = useMe();
  const { data = [] } = useQuery({ queryKey: ["myapps"], queryFn: () => api.get("/applications/me").then((r) => r.data.items), enabled: !!me });
  if (!me || !data.length) return null;
  return (
    <div id="mine" className="glass mt-6 scroll-mt-24 rounded-2xl p-6" data-testid="my-applications">
      <h3 className="font-disp text-lg font-bold">تقديماتي</h3>
      <div className="mt-4 space-y-2">
        {data.map((a) => (
          <div key={a.id} className="flex items-center justify-between rounded-xl border border-sky-400/10 bg-black/30 px-4 py-3 text-sm" data-testid={`my-app-${a.id}`}>
            <span>{TYPE_LABEL[a.type]}</span>
            <span className="flex items-center gap-3"><span className="font-mono2 text-xs text-slate-500">{a.created_at.slice(0, 10)}</span><Tag tone={STATUS[a.status][1]}>{STATUS[a.status][0]}</Tag></span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function Apply() {
  const { data: s } = useSettings();
  const { data: depts = [] } = useContent("departments");
  return (
    <>
      <PageHead kicker="APPLY" title="التقديم للمدينة" desc="هذا التقديم للانضمام للمدينة نفسها. بعد ما تنقبل تقدر تقدّم على أي قسم من صفحة القسم." />
      <Section className="grid gap-10 lg:grid-cols-[1.3fr_1fr]">
        <div>
          <ApplyForm type="city" fields={CITY_FIELDS} next="/apply" closed={s && !s.city_apply_open} />
          <MyApps />
        </div>
        <div>
          <div className="kicker">DEPARTMENTS</div>
          <h2 className="font-disp mt-2 text-2xl font-bold">التقديم على الأقسام</h2>
          <p className="mt-2 text-sm text-slate-400">لكل قسم تقديم وشروط خاصة فيه.</p>
          <div className="mt-6 space-y-3">
            {depts.map((d) => (
              <Link key={d.slug} to={`/apply/${d.slug}`} className="card-hover glass flex items-center gap-4 rounded-2xl p-4" data-testid={`apply-dept-link-${d.slug}`}>
                <img src={d.image} alt="" className="h-14 w-14 rounded-xl object-cover" />
                <div className="flex-1"><div className="font-semibold">{d.name}</div><div className="kicker !text-[10px]">{d.tag}</div></div>
                {d.soon ? <Tag tone="gold">قريباً</Tag> : !d.open ? <Tag tone="mute">مقفل</Tag> : <ArrowLeft size={18} className="text-sky-300" />}
              </Link>
            ))}
          </div>
        </div>
      </Section>
    </>
  );
}
